import React from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react';
export function TarotExplanationSection() {
  return <section className="py-24 px-4 bg-[#111522] text-[#F7F5F2]" data-id="element-395">
      <div className="max-w-4xl mx-auto" data-id="element-396">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-16" data-id="element-397">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-398">
            <Eye className="w-8 h-8 text-[#CFA86A]" strokeWidth={1.5} data-id="element-399" />
            <h2 className="text-4xl md:text-5xl font-serif text-[#CFA86A]" data-id="element-400">
              Lo que el tarot ES (y lo que no)
            </h2>
          </div>
        </motion.div>

        {/* Gancho */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.1,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-16" data-id="element-401">
          <p className="text-2xl md:text-3xl font-light text-[#F7F5F2] leading-relaxed mb-2" data-id="element-402">
            El tarot no predice tu destino.
          </p>
          <p className="text-2xl md:text-3xl font-semibold text-[#CFA86A] leading-relaxed" data-id="element-403">
            Te muestra por qué sigues sin decidir.
          </p>
        </motion.div>

        {/* Qué es */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="mb-12" data-id="element-404">
          <h3 className="text-2xl font-serif font-bold text-[#CFA86A] mb-4 text-center" data-id="element-405">
            Qué es
          </h3>
          <p className="text-lg text-[#F7F5F2]/80 leading-relaxed text-center max-w-3xl mx-auto" data-id="element-406">
            El tarot es una herramienta visual para entender lo que sientes,
            aclarar lo que quieres y ver lo que estás evitando decidir. No
            inventa respuestas: te enfrenta a las tuyas.
          </p>
        </motion.div>

        {/* Qué NO es */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="mb-12" data-id="element-407">
          <h3 className="text-2xl font-serif font-bold text-[#CFA86A] mb-4 text-center" data-id="element-408">
            Qué NO es
          </h3>
          <div className="space-y-4 max-w-3xl mx-auto" data-id="element-409">
            <p className="text-lg text-[#F7F5F2]/80 leading-relaxed text-center" data-id="element-410">
              El tarot no es malo, ni prohibido, ni contrario a tu fe.
            </p>
            <p className="text-lg text-[#F7F5F2]/80 leading-relaxed text-center" data-id="element-411">
              No invoca nada, no manipula energías, no te obliga a creer en algo
              distinto. La mala fama viene del miedo, no de la experiencia.
            </p>
            <p className="text-xl font-semibold text-[#F7F5F2] leading-relaxed text-center mt-6" data-id="element-412">
              No te quita tu religión.
            </p>
            <p className="text-xl font-semibold text-[#CFA86A] leading-relaxed text-center" data-id="element-413">
              Te quita la confusión.
            </p>
          </div>
        </motion.div>

        {/* Por qué funciona */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="mb-12" data-id="element-414">
          <h3 className="text-2xl font-serif font-bold text-[#CFA86A] mb-4 text-center" data-id="element-415">
            Por qué funciona
          </h3>
          <p className="text-lg text-[#F7F5F2]/80 leading-relaxed text-center max-w-3xl mx-auto mb-4" data-id="element-416">
            Cuando puedes ver tus deseos, tus bloqueos y tu siguiente paso sin
            autoengaños, decidir deja de ser difícil.
          </p>
          <p className="text-xl font-light text-[#F7F5F2] leading-relaxed text-center mt-6" data-id="element-417">
            El tarot no te dice qué va a pasar.
          </p>
          <p className="text-xl font-semibold text-[#CFA86A] leading-relaxed text-center" data-id="element-418">
            Te deja sin excusas para no avanzar.
          </p>
        </motion.div>

        {/* Frase de cierre */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        delay: 0.5,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mt-16 pt-8 border-t border-[#CFA86A]/20" data-id="element-419">
          <p className="text-2xl md:text-3xl font-light text-[#F7F5F2] leading-relaxed mb-2" data-id="element-420">
            El tarot no cambia tu vida.
          </p>
          <p className="text-2xl md:text-3xl font-semibold text-[#CFA86A] leading-relaxed" data-id="element-421">
            Cambia la forma en que decides — y eso lo cambia todo.
          </p>
        </motion.div>
      </div>
    </section>;
}